import { StyleSheet } from 'react-native';


const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    padding: 20,
    alignContent: 'center',
    justifyContent: 'center',
  },

  container:{
  },

  imageLoginContainer:{
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },

  titulo1: {
    fontSize: 50,
    color: "white",
    fontWeight: 'bold',
    marginTop: -10,
  },

  titulo2: {
    fontSize: 35,
    color: "white",
    fontWeight: 'bold'
  },

  subTitle: {
    fontSize: 45,
    color: '#151515',
    marginTop: 80,
    margin: 50,
    fontWeight: 'bold',

  },
  textLabels: {

    padding: 5,
    width: '80%',
    marginTop: 5,
    fontWeight: 'bold',
    color: '#ffff',
    fontSize: 20
  },
  textLabels2: {

    padding: 5,
    width: '80%',
    marginTop: 50,
    fontWeight: 'bold',
    color: '#ffff',
    fontSize: 20,
    paddingTop: "40%"
  },
  textInput: {
    marginBottom: 10,

  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: 1000,
  },

  subTitle2: {
    fontSize: 15,
    color: 'gray',
    marginTop: 5,
    fontWeight: 'bold'

  }, container2: {

    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    width: '80%',
    height: 50


  },


});

export default styles
